import axios from 'axios';
import { Todo, CreateTodoDto, UpdateTodoDto } from '../types/todo';

const apiClient = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/users`,
});

const getGUID = () => localStorage.getItem('user_guid');

export const fetchTodos = async (): Promise<Todo[]> => {
  const userId = getGUID();
  const response = await apiClient.get(`/${userId}`);
  return response.data.todos;
};

export const createTodo = async (data: CreateTodoDto): Promise<Todo[]> => {
  const userId = getGUID();
  try {
    const response = await apiClient.post(`/${userId}/todos`, data);
    
    return response.data.todos;
  } catch (error: unknown) {
    throw error;
  }
};

export const updateTodo = async (todoId: string, data: UpdateTodoDto): Promise<Todo[]> => {
  const userId = getGUID();
  const response = await apiClient.patch(`/${userId}/todos/${todoId}`, data);
  return response.data.todos;
};

export const deleteTodo = async (todoId: string): Promise<Todo[]> => {
  const userId = getGUID();
  const response = await apiClient.delete(`/${userId}/todos/${todoId}`);
  return response.data.todos;
};
